import {OutlineFilter} from '@pixi/filter-outline';
import {Container} from '@inlet/react-pixi';
import {TextBox} from '@gongxigames/framework/core/fragments/react';
import React from 'react';
import {CheatsButton, CheatsButtonButtonProps} from './CheatsButton';

export type ToggleButtonWithTitleProps = {
    onChange: (value: boolean) => void;
    value: boolean;
    title: string;
    fontSize: number;
} & CheatsButtonButtonProps;

export class ToggleButtonWithTitle extends CheatsButton<ToggleButtonWithTitleProps> {
    protected static STATE = {
        NORMAL: {
            filters: [new OutlineFilter(2, 0x000000)],
            background: 0x808898
        },
        OVER: {
            filters: [new OutlineFilter(2, 0xFF0000)],
            background: 0x697281
        },
        DOWN: {
            filters: [new OutlineFilter(1, 0x000000)],
            background: 0xA7B2C7
        }
    };

    protected onPointerTap(): void {
        if (this.props.disabled) {
            return;
        }

        if (this.props.onChange) {
            this.props.onChange(!this.props.value);
        }
    }

    public render(): JSX.Element {
        const fill = this.props.value ? 0xFF0000 : this.state.currentState.background;

        return (
            <Container {...this.getContainerProps()} >
                <TextBox
                    text={this.props.title}
                    round={4}
                    background={fill}
                    boxWidth={this.props.width}
                    boxHeight={this.props.height}
                    textStyle={{fontSize: this.props.fontSize, fill: 0xffffff}}
                    textAlign={{horizontal: 'center', vertical: 'center'}}
                    padding={{left: 20, right: 20}}
                />
            </Container>
        );
    }
}
